import React from "react";
import { Link } from "react-router-dom";
import Api from "../../servicios/api";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { faSearch, faUpload, faPlus, faViruses } from '@fortawesome/free-solid-svg-icons'
import Swal from 'sweetalert2';

class Listar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      datosCargados: false,
      query: [],
      pagina: [],
    };
  }
  borrarRegistros = (id) => {
    console.log(id);
    Swal.fire({
      title: 'Estas seguro de eliminar el registro?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Borrar',
      denyButtonText: `No borrar`,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        fetch(Api + "DelRoles/" + id)
          .then((respuesta) => respuesta.json())
          .then((datosRespuesta) => {
            console.log(datosRespuesta);
            Swal.fire('Borrado!', datosRespuesta.msj, 'success')
            this.Buscar(1);
          })
          .catch(console.log);
      } else if (result.isDenied) {
        Swal.fire('Cancelado', '', 'info')
      }
    })
  };
  cargarRoles() {
    console.log("Formulario Enviado...");
    fetch(Api + "Roles")
      .then((respuesta) => respuesta.json())
      .then((datosRespuesta) => {
        this.setState({ datosCargados: true, query: datosRespuesta });
      })
      .catch(console.log);
  }
  componentDidMount() {
    this.cargarRoles();
  }
  render() {
    const { datosCargados, query } = this.state;
    if (!datosCargados) {
      var load = 'Cargando datos....';
    } else {
      var load = '';
    }
    return (
      <div className="content">
        <div className="container-fluid">
          <div className="card">
            <div className="card-header">
              <Link className="btn btn-success btn-sm" to={"/AddRoles"}>
                Agregar Roles
              </Link>
            </div>
            <div className="card-body">
              <h4>Lista de Roles</h4>
              <div className="row">
                <table className="table table-hover table-condensed table-sm">
                  <thead className="thead-inverse">
                    <tr>
                      <th>NOMBRE ROL</th>
                      <th>DESCRIPCIÓN</th>
                      <th>ACCIONES</th>
                    </tr>
                  </thead>
                  <tbody>
                    {load}
                    {query.map((roles) => (
                      <tr key={roles.id_roles}>
                        <td>{roles.nombre}</td>
                        <td>{roles.descripcion}</td>
                        <td>
                          <div className="btn-group" role="group" aria-label="">
                            <Link
                              className="btn btn-primary btn-sm"
                              to={"/UpRoles/" + roles.id_roles}
                            >
                              <i class="fas fa-edit"></i>
                            </Link>&nbsp;&nbsp;
                            <button
                              type="button"
                              className="btn btn-danger btn-sm"
                              onClick={() =>
                                this.borrarRegistros(roles.id_roles)
                              }
                            >
                              <i class="far fa-trash-alt"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>


    );
  }
}


export default Listar;
